import { faArrowsRotate } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

import { useRefreshAttendanceChecklist } from '@/hooks/useEncounters';
import { TimeAgo, Tooltip, Typography } from '@/ui';

import './styles.css';
import type { Props } from './types';

const NO_BILLING_ITEM = 'No billing item to refresh yet';

/**
 * Regenerates the encounter's billing item, which both the provider checklist
 * and the billing card read, so either card can offer it.
 */
const EncounterRefreshButton = ({ cachedAt, encounterId, hasBillingItem }: Props) => {
  const { mutate: refresh, isPending } = useRefreshAttendanceChecklist({ encounterId });

  return (
    <div className="flex items-center gap-2">
      <Tooltip content={hasBillingItem ? 'Refresh billing item' : NO_BILLING_ITEM}>
        {/* aria-disabled rather than disabled, so the tooltip still opens on hover and focus */}
        <button
          aria-disabled={!hasBillingItem || undefined}
          className="flex items-center gap-1 text-xs text-slate-500 hover:text-slate-800 disabled:opacity-50 aria-disabled:cursor-not-allowed aria-disabled:opacity-50 aria-disabled:hover:text-slate-500 dark:hover:text-slate-200"
          disabled={isPending}
          onClick={() => hasBillingItem && refresh()}
          type="button">
          <FontAwesomeIcon aria-hidden icon={faArrowsRotate} spin={isPending} />
          Refresh
        </button>
      </Tooltip>
      {/* Dropped when the section header it sits in is too narrow to spare it */}
      {cachedAt && (
        <Typography className="hidden @xs:block" muted variant="caption">
          Updated <TimeAgo date={cachedAt} />
        </Typography>
      )}
    </div>
  );
};

export default React.memo(EncounterRefreshButton);
